import { render, staticRenderFns } from "./UpdatedSeries.vue?vue&type=template&id=154db20c&"
import script from "./UpdatedSeries.vue?vue&type=script&lang=js&"
export * from "./UpdatedSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports